export default "__VITE_ASSET__BBXaWs03__"